
import { Variant } from "./Variant.js";
import { CustomInterval__ToI18nString, ReminderInterval__ToI18nString, Customer } from "./Shared/Shared.js";
import { toLocalTime, toString } from "./fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { singleton, ofArray, append, tail, head, isEmpty, filter, empty, tryFind } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_encodeQueryString, RouterModule_nav, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { map, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { item } from "./fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { comparePrimitives, equals } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_1 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryParse } from "./fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FSharpRef } from "./fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { contains, ofList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { tryParse as tryParse_1 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Int32.js";
import { interpolate, toText, replace } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function parseCustomer(customerName) {
    if (Variant.tag === 0) {
        switch (customerName) {
            case "sww-staging-account":
                return new Customer(2, []);
            case "prinzing-elektrotechnik-gmbh":
                return new Customer(1, []);
            case "elektro-schöffmann-gmbh-&-co.-kg":
                return new Customer(3, []);
            case "sbucher-abbruch-und-recycling-gmbh":
                return new Customer(4, []);
            case "wasser-nord-gmbh-&-co.-kg":
                return new Customer(5, []);
            case "1557":
                return new Customer(7, []);
            case "1855":
                return new Customer(9, []);
            default:
                return new Customer(0, []);
        }
    }
    else {
        switch (customerName) {
            case "169":
                return new Customer(6, []);
            case "232":
                return new Customer(8, []);
            default:
                return new Customer(0, []);
        }
    }
}

export const numberInputIntMaxValue = 2147483647;

export function formatReminderInterval(t, interval, customInterval) {
    let matchResult;
    if (interval.tag === 6) {
        if (customInterval != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const ci = customInterval;
            return `${t(ReminderInterval__ToI18nString(interval))} (${ci.Value} ${t(CustomInterval__ToI18nString(ci.Interval))})`;
        }
        default:
            return t(ReminderInterval__ToI18nString(interval));
    }
}

export function toISOString(dateTime) {
    return toString(dateTime, "yyyy-MM-ddTHH:mm:ss.fffffffZ", {});
}

export function toLocalISOString(dateTime) {
    return toString(toLocalTime(dateTime), "yyyy-MM-ddTHH:mm:ss.fffffffZ", {});
}

export function getQueryParams(_arg) {
    const matchValue = tryFind((segment) => segment.startsWith("?"), RouterModule_urlSegments(window.location.hash, 1));
    if (matchValue == null) {
        return empty();
    }
    else {
        const queryParams = matchValue;
        return toList(map((query) => [item(0, query), item(1, query)], (new URLSearchParams(queryParams)).entries()));
    }
}

function pathSegmentsWithoutQuery() {
    return filter((s) => {
        if (s.length === 0) {
            return true;
        }
        else {
            return s[0] !== "?";
        }
    }, RouterModule_urlSegments(window.location.hash, 1));
}

export function withoutOnboardingTourQueryParams() {
    return filter((tupledArg) => {
        const k = tupledArg[0];
        if ((k !== "onboardingTourStep") && (k !== "phase")) {
            return k !== "listTour";
        }
        else {
            return false;
        }
    }, getQueryParams(undefined));
}

export function withoutProblemReportIdQueryParam() {
    return filter((tupledArg) => (tupledArg[0] !== "problemReportId"), getQueryParams(undefined));
}

export function isCategoryLabelsTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "category-labels-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "settings") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "categories") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isCategoryLabelsTourFormPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "category-labels-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "settings") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "categories") {
                        if (!isEmpty(tail(tail(matchValue)))) {
                            if (head(tail(tail(matchValue))) === "new") {
                                if (isEmpty(tail(tail(tail(matchValue))))) {
                                    matchResult = 0;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isManageStoragesTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "manage-storages-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "storages") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isManageStoragesTourFormPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "manage-storages-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "storages") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "new") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isSetBundlesTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "set-bundles-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "tools") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isCustomFieldsTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "custom-fields-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "settings") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "custom-properties") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isBusinessUnitsTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "business-units-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "business-units") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isBusinessUnitsTourFormPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "business-units-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "business-units") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "new") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isTenantsOnboardingTourPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "tenants-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "dashboard") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isChatOnboardingTourPermissionsPhase() {
    const step = map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined)));
    const phase = map_1((tuple_3) => tuple_3[1], tryFind((arg_1) => ("phase" === arg_1[0]), getQueryParams(undefined)));
    if (!equals(step, "chat-step") ? true : !equals(phase, "permissions")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "settings") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "permissions") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function reloadAppToDashboard() {
    window.location.href = ((window.location.origin + window.location.pathname) + "#/dashboard");
}

export function isStocktakingTourOverviewPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "stocktaking-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "stocktaking") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isStocktakingTourFormPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "stocktaking-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "stocktaking") {
                if (!isEmpty(tail(matchValue))) {
                    if (head(tail(matchValue)) === "new") {
                        if (isEmpty(tail(tail(matchValue)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function queryParamsForCreateInventoryTourForm() {
    return append(ofArray([["onboardingTourStep", "create-inventory-step"], ["phase", "form"]]), filter((tupledArg) => {
        const k = tupledArg[0];
        if (k !== "onboardingTourStep") {
            return k !== "phase";
        }
        else {
            return false;
        }
    }, getQueryParams(undefined)));
}

export function isCreateInventoryFormOnboardingTourPhase() {
    const qp = getQueryParams(undefined);
    const step = map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), qp));
    const phase = map_1((tuple_3) => tuple_3[1], tryFind((arg_1) => ("phase" === arg_1[0]), qp));
    if (equals(step, "create-inventory-step")) {
        return equals(phase, "form");
    }
    else {
        return false;
    }
}

export function isCreateInventoryOnboardingTourOverviewPhase() {
    const qp = getQueryParams(undefined);
    const step = map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), qp));
    const phase = map_1((tuple_3) => tuple_3[1], tryFind((arg_1) => ("phase" === arg_1[0]), qp));
    if (equals(step, "create-inventory-step")) {
        return !equals(phase, "form");
    }
    else {
        return false;
    }
}

export function isAssignToolsOnboardingTourTablePhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "assign-tools-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "tools") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isFilterSearchOnboardingTourTablePhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "filter-search-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "tools") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isInspectionOnboardingPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "inspection-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "inspection-templates") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isAssignToolsOnboardingTourToolDetailPhase() {
    let outArg;
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "assign-tools-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult, segment_1;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "tools") {
                if (!isEmpty(tail(matchValue))) {
                    if (isEmpty(tail(tail(matchValue)))) {
                        if (head(tail(matchValue)) !== "new") {
                            matchResult = 0;
                            segment_1 = head(tail(matchValue));
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return ((outArg = "00000000-0000-0000-0000-000000000000", [tryParse(segment_1, new FSharpRef(() => outArg, (v) => {
                    outArg = v;
                })), outArg]))[0];
            default:
                return false;
        }
    }
}

const whoHasWhatListTourDoneParam = "listTour";

export function whoHasWhatListTourIsDoneInQuery() {
    return equals("done", map_1((tuple_1) => tuple_1[1], tryFind((arg) => (whoHasWhatListTourDoneParam === arg[0]), getQueryParams(undefined))));
}

const receiverOverviewSubpathSegments = ofList(ofArray(["users", "employees", "rooms", "external-persons", "subcontractors", "projects", "construction-sites", "students", "school-classes", "vehicles"]), {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

export function isWhoHasWhatOnboardingReceiversListPhase() {
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "who-has-what-step")) {
        return false;
    }
    else if (whoHasWhatListTourIsDoneInQuery()) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "receivers") {
                if (isEmpty(tail(matchValue))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function isWhoHasWhatOnboardingReceiverDetailPhase() {
    let second;
    if (!equals(map_1((tuple_1) => tuple_1[1], tryFind((arg) => ("onboardingTourStep" === arg[0]), getQueryParams(undefined))), "who-has-what-step")) {
        return false;
    }
    else {
        const matchValue = pathSegmentsWithoutQuery();
        let matchResult, second_1;
        if (!isEmpty(matchValue)) {
            if (head(matchValue) === "receivers") {
                if (!isEmpty(tail(matchValue))) {
                    if (isEmpty(tail(tail(matchValue)))) {
                        if ((second = head(tail(matchValue)), (!contains(second, receiverOverviewSubpathSegments) && (second !== "new")) && !(second === "edit"))) {
                            matchResult = 0;
                            second_1 = head(tail(matchValue));
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }
}

export function whoHasWhatNavigateReceiversListWithListTourDone() {
    RouterModule_nav(singleton("receivers" + RouterModule_encodeQueryString(append(ofArray([["onboardingTourStep", "who-has-what-step"], [whoHasWhatListTourDoneParam, "done"]]), filter((tupledArg) => {
        const k = tupledArg[0];
        if (k !== "onboardingTourStep") {
            return k !== whoHasWhatListTourDoneParam;
        }
        else {
            return false;
        }
    }, getQueryParams(undefined))))), 1, 1);
}

export function tryParsePrice(value) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse_1(value, 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
        outArg = (v | 0);
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}

export function priceToString(price, currency) {
    return replace(toText(interpolate("%.2f%P() %P()", [price / 100, (currency === "cHF") ? "CHF" : "€"])), ".", ",");
}

